
export const END_POINT_DEFINITIONS = "/EndPointDefinition/GetEndPointDefinitions"
export const END_POINT_DEFINITION_INSERT = "/EndPointDefinition/InsertEndPointDefinition"
export const END_POINT_DEFINITION_UPDATE = "/EndPointDefinition/UpdateEndPointDefinition"
export const END_POINT_DEFINITION_DELETE = "/EndPointDefinition/DeleteEndPointDefinition"
